import { render } from "./DisclaimerDialog.vue?vue&type=template&id=43f32a05"
import script from "./DisclaimerDialog.vue?vue&type=script&lang=js"
export * from "./DisclaimerDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__